import React from 'react';
import { string } from 'prop-types';
import { themeObj } from 'TMComponents/GlobalStyle';

const Arrow = ({ color = themeObj.colorSystem.UIText[1] }) => (
    <svg
        width="17"
        height="20"
        viewBox="0 0 17 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_10036_50534)">
            <path
                d="M16.2357 9.37852C16.4036 9.5428 16.5 9.76423 16.5 9.99995C16.5 10.2357 16.4036 10.4571 16.2357 10.6214L9.95 16.6214C9.60714 16.9499 9.06429 16.9357 8.73929 16.5928C8.41429 16.2499 8.425 15.7071 8.76786 15.3821L13.5036 10.8571L1.35714 10.8571C0.882143 10.8571 0.500001 10.4749 0.500001 9.99995C0.500001 9.52495 0.882143 9.1428 1.35714 9.1428L13.5036 9.1428L8.76429 4.62137C8.42143 4.2928 8.41072 3.75352 8.73572 3.41066C9.06072 3.0678 9.60357 3.05709 9.94643 3.38209L16.2321 9.38209L16.2357 9.37852Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_10036_50534">
                <rect
                    width="16"
                    height="18.2857"
                    fill={color}
                    transform="translate(16.5 19.1428) rotate(-180)"
                />
            </clipPath>
        </defs>
    </svg>
);

Arrow.propTypes = {
    color: string
};

export default Arrow;
